import { useEffect } from "react";

export const SITE_URL = "https://neatwavecleaning.co.uk";
export const SERVICE_AREAS = ["Cardiff", "Barry", "Penarth"];
export const PROVIDER = { "@type": "LocalBusiness", "@id": `${SITE_URL}/#business`, name: "NeatWave Cleaning Services", telephone: "+447492865011", url: SITE_URL };

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

const setMeta = (selector, attr, value) => document.querySelector(selector)?.setAttribute(attr, value);

// Sets title, description, canonical, social tags and page-level JSON-LD.
export const usePageMeta = ({ title, description, schemas = [] }) => {
  const schemaKey = JSON.stringify(schemas);
  useEffect(() => {
    const url = `${SITE_URL}${window.location.pathname}`;
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;
    const nodes = JSON.parse(schemaKey).map((s) => {
      const ld = document.createElement("script");
      ld.type = "application/ld+json";
      ld.dataset.pageSchema = "true";
      ld.text = JSON.stringify(s);
      document.head.appendChild(ld);
      return ld;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [title, description, schemaKey]);
};
